<template>
  <v-container id="wizard" tag="section"
    ><v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("newEquipment.modulesButton") }}</span>
    </v-tooltip>
    <validation-observer v-slot="{ valid }">
      <base-material-wizard
        v-model="tab"
        :available-steps="availableSteps"
        :items="translateTabs(tabs)"
        :title="$t('newEquipment.equipment')"
        class="mx-auto"
        @click:next="next(valid)"
        @click:prev="tab--"
      >
        <v-tab-item class="pb-12">
          <form>
            <v-row class="mx-auto" justify="space-around">
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.equipmentTag')"
                >
                  <v-text-field
                    v-model="equipmentProfile.equipTag"
                    :error-messages="errors"
                    color="gray"
                    :label="$t('newEquipment.equipmentTag')"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.manufacturer')"
                >
                  <v-text-field
                    v-model="equipmentProfile.manufacturer"
                    :error-messages="errors"
                    color="gray"
                    :label="$t('newEquipment.manufacturer')"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.model')"
                >
                  <v-text-field
                    v-model="equipmentProfile.model"
                    :error-messages="errors"
                    color="gray"
                    :label="$t('newEquipment.model')"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
              <!--   <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="Product"
                >
                  <v-text-field
                    v-model="equipmentProfile.product"
                    :error-messages="errors"
                    color="gray"
                    label="Product"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col> -->
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.hazardous')"
                >
                  <v-select
                    filled
                    :label="$t('newEquipment.hazardous')"
                    :items="hazardous"
                    item-text="name"
                    item-value="name"
                    v-model="equipmentProfile.hazardous"
                    :error-messages="errors"
                    color="gray"
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
              <!--  <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.hazardous')"
                >
                  <v-select
                    filled
                    v-model="equipmentProfile.sealType"
                    :label="$t('newEquipment.sealTypes')"
                    :items="sealTypes"
                    item-text="name"
                    item-value="name"
                    :error-messages="errors"
                    color="gray"
                    validate-on-blur
                    return-object
                  ></v-select></validation-provider
              ></v-col> -->
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.equipmentStatus')"
                >
                  <v-select
                    filled
                    v-model="equipmentProfile.status"
                    :label="$t('newEquipment.equipmentStatus')"
                    :items="translateStatus(status)"
                    item-text="name"
                    item-value="name"
                    :error-messages="errors"
                    color="gray"
                    validate-on-blur
                  ></v-select>
                </validation-provider>
              </v-col>

              <!-- <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.mechanical')"
                >
                  <v-text-field
                    filled
                    :label="$t('newEquipment.mechanical')"
                    v-model="equipmentProfile.mechanicalSealCode"
                    :error-messages="errors"
                    color="gray"
                    validate-on-blur
                  ></v-text-field
                ></validation-provider>
              </v-col> -->
              <v-col cols="12" md="6" justify="center" align="center">
                <ubication
                  @doneUbication="setUbicationOnEquipmentProfile"
                ></ubication>
              </v-col>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('newEquipment.equipmentType')"
                >
                  <v-autocomplete
                    v-model="equipmentProfile.equipmentType"
                    :items="equipmentType"
                    :item-text="equipmentTypeName"
                    return-object
                    item-color="success"
                    prepend-icon="mdi-database-search"
                    :label="$t('newEquipment.equipmentType')"
                    validate-on-blur
                    :error-messages="errors"
                  >
                  </v-autocomplete>
                </validation-provider>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="equipmentProfile.comment"
                  :label="$t('newEquipment.comment')"
                ></v-textarea>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
        <v-tab-item class="pb-12">
          <form>
            <v-row class="mx-auto" justify="space-around">
              <v-col
                cols="12"
                md="6"
                v-for="(opVal, index) in operationalValues"
                :key="opVal.code"
              >
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t(`variables.${opVal.code}`)"
                >
                  <v-text-field
                    v-model="
                      equipmentProfile.equipmentType.operationalValues[index]
                        .value
                    "
                    :error-messages="errors"
                    color="gray"
                    :hint="unit(opVal.type) | capitalize"
                    :label="$t(`variables.${opVal.code}`)"
                    persistent-hint=""
                    validate-on-blur
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </form>
        </v-tab-item>
        <v-tab-item class="pb-12">
          <v-container>
            <v-subheader class="pa-0">Select equipments variables</v-subheader>
            <v-autocomplete
              v-model="equipmentProfile.variables"
              :items="variableList"
              multiple=""
              chips
              small-chips
              persistent-hint
              :item-text="variableName"
              return-object=""
              item-color="success"
              prepend-icon="mdi-database-search"
            >
            </v-autocomplete>
          </v-container>
        </v-tab-item>
      </base-material-wizard>
    </validation-observer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { unitDefault, unitTypes } from "@/settings/unitTypes";
import writeValues from "@/mixins/writeValues";
export default {
  name: "DashboardFormsWizard",
  components: {
    ubication: () => import("./Ubication")
  },
  mixins: [writeValues],

  data: () => ({
    equipmentProfile: {},
    tab: 0,
    status: [
      {
        name: "Running",
        color: "#008450",
        value: 1
      },
      {
        name: "Standby",
        color: "#EFB700",
        value: 2
      },
      {
        name: "Maintenance",
        color: "#DA530A",
        value: 3
      },
      {
        name: "Failure",
        color: "#B81D13",
        value: 4
      }
    ],
    tabs: ["Basic Information", "Operational Values", "Variable Ranges"]
  }),
  computed: {
    ...mapState("settings", ["hazardous", "sealTypes", "equipmentType"]),
    variableList() {
      return this.equipmentProfile?.equipmentType?.variables;
    },
    operationalValues() {
      return this.equipmentProfile?.equipmentType?.operationalValues;
    },
    scope() {
      if (this.tab === 0) return "Basic Information";
      else if (this.tab === 1) return "Operational Values";
      return "Variable Ranges";
    },
    availableSteps() {
      const steps = [0];
      if (
        this.equipmentProfile?.equipmentType &&
        this.equipmentProfile?.equipTag &&
        this.equipmentProfile?.status &&
        this.equipmentProfile?.hazardous &&
        this.equipmentProfile?.manufacturer &&
        this.equipmentProfile?.model &&
        this.equipmentProfile?.unit
      )
        steps.push(1);
      if (
        this.equipmentProfile?.equipmentType?.operationalValues &&
        steps.includes(1)
      ) {
        steps.push(2);
      }
      if (this.equipmentProfile?.variables?.length > 0 && steps.includes(2))
        steps.push(3);
      return steps;
    }
  },

  methods: {
    variableName(item) {
      let name = this.$t(`variables.${item.code}`);
      let group = item.groups;
      return `[${group}] ${name}`;
    },
    setUbicationOnEquipmentProfile(payload) {
      this.equipmentProfile.plant = payload.plant;
      this.equipmentProfile.area = payload.area;
      this.equipmentProfile.unit = payload.unit;
    },
    equipmentTypeName(item) {
      let name = item.name;
      let mainClass = item.mainClass;
      let subtype = item.subtype ? `- ${item.subtype}` : "";
      return `[${mainClass}] ${name} ${subtype}`;
    },
    next(valid) {
      if (!valid) return;
      if (this.tab === this.tabs.length - 1) {
        this.submit();
      } else {
        this.tab++;
      }
    },
    transformValue(variable) {
      if (variable?.type === unitTypes.deathLine) {
        return new Date();
      }
      if (variable?.type === "unique") {
        return variable.value;
      } // transforma la variable si no es metrico a metrico.
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(this.saveUnit(variable?.value, variable?.type, unit));
      }
    },
    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    },
    async submit() {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      this.equipmentProfile.operationalValues = this.operationalValues;
      //init docs and drawing array
      this.equipmentProfile.drawings = [];
      this.equipmentProfile.datasheet = [];
      this.equipmentProfile.location = [0, 0];
      this.equipmentProfile.disabled = false;
      this.equipmentProfile?.operationalValues?.forEach(variable => {
        variable.value = this.transformValue(variable);
      });
      this.equipmentProfile.equipmentType = this.equipmentProfile.equipmentType.id;
      this.equipmentProfile.createdBy = this.$store.state.auth.user.email;
      this.equipmentProfile.dateCreated = new Date();
      let payload = {
        db: "equipments",
        data: this.equipmentProfile
      };
      try {
        let responseUid = await this.$store.dispatch("addDocument", payload);
        loading.close();
        this.$dialog.notify.success(
          "Equipment was created successfully, you will be redirect",
          {
            position: "top-right",
            timeout: 5000
          }
        );
        setTimeout(() => {
          this.$router.push("/equipment/" + responseUid);
        }, 4000);
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    translateStatus(list) {
      var temp = list.slice();
      var i;
      for (i = 0; i < temp.length; i++) {
        switch (temp[i].name) {
          case "Running":
            temp[i].name = this.$t("reliability.statuslights.running");
            break;
          case "Standby":
            temp[i].name = this.$t("reliability.statuslights.standby");
            break;
          case "Maintenance":
            temp[i].name = this.$t("reliability.statuslights.maintenance");
            break;
          case "Failure":
            temp[i].name = this.$t("reliability.statuslights.failure");
            break;
          default:
          // code block
        }
      }
      return temp;
    },
    translateTabs(list) {
      var temp = list.slice();
      var i;
      for (i = 0; i < temp.length; i++) {
        switch (temp[i]) {
          case "Basic Information":
            temp[i] = this.$t("newEquipment.tabs.info");
            break;
          case "Operational Values":
            temp[i] = this.$t("newEquipment.tabs.values");
            break;
          case "Variable Ranges":
            temp[i] = this.$t("newEquipment.tabs.ranges");
            break;
          default:
          // code block
        }
      }
      return temp;
    }
  }
};
</script>
<style lang="sass">
.v-card.v-card.v-card--account
  border-color: currentColor
  border-width: 4px
.v-icon
  color: inherit
.v-card--account,
.v-card--account:before
  border-radius: 50%
</style>
